import { Stack, Text } from "@/components/ui";

interface Props {
  label: string;
  value: string;
  mono?: boolean;
}

/** Display key-value compacto · etiqueta uppercase + valor. */
export function KV({ label, value, mono }: Props) {
  return (
    <Stack gap={2}>
      <Text size="xs" c="dimmed" tt="uppercase" className="tracking-wide" style={{ fontSize: 10 }}>
        {label}
      </Text>
      <Text size="sm" ff={mono ? "mono" : undefined}>{value}</Text>
    </Stack>
  );
}
